export enum ColumnFilterTypeEnum {
    SEARCH = 'SEARCH',
    SELECT_SEARCH = 'SELECT_SEARCH',
    MULTIPLE = 'MULTIPLE',
    SINGLE = 'SINGLE'
}
